import { SENSOR_STATUS_MAP, type InactiveSensorStatus } from '../types';

interface SensorStatusBadgeProps {
  status: InactiveSensorStatus;
}

/**
 * Color-coded badge for sensor status
 */
export function SensorStatusBadge({ status }: SensorStatusBadgeProps) {
  const config = SENSOR_STATUS_MAP[status];

  if (!config) {
    return (
      <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-gray-100 text-gray-700">
        Unknown
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${config.bgColor} ${config.textColor}`}
    >
      {config.label}
    </span>
  );
}
